import apiPrd from '../../services/apiPrd'
import apiSystem from '../../services/apiSystem'

const SettingsService = {
  async listAllContacts(transporterId) {
    const res = await apiPrd.get(`/transporter/${transporterId}/contacts/findAll`)
    return res.data
  },
  async createContact(transporterId, payload) {
    const res = await apiPrd.post(`/transporter/${transporterId}/contacts/add`, payload)
    return res.data
  },
  async updateContact(transporterId, contactId, payload) {
    const res = await apiPrd.put(
      `/transporter/${transporterId}/contacts/updated/${contactId}`,
      payload
    )
    return res.data
  },
  async deleteContact(transporterId, contactId) {
    const res = await apiPrd.delete(`/transporter/${transporterId}/contacts/delete/${contactId}`)
    return res.data
  },

  async fetchTransporterUserInfo() {
    const res = await apiPrd.get('/transporter/info')
    return res.data
  },
  async fetchTransporterInfo() {
    const res = await apiPrd.get('/transporter/me')
    return res.data
  },
  async fetchAvailableProperties() {
    const res = await apiSystem.get('/property')
    return res.data
  },
  async fetchAvailableCertificates() {
    const res = await apiSystem.get('/certification')
    return res.data
  },
  async fetchLoadProfileById(id) {
    const res = await apiPrd.get(`/profile/${id}`)
    return res.data
  },
  async postNewProfile(profile) {
    const res = await apiPrd.post('/profile', profile)
    return res.data
  },
  async updateProfileById(profile) {
    const res = await apiPrd.put(`/profile/${profile.id}`, profile)
    return res.data
  },
  async updateTransporterInfo(data) {
    const res = await apiPrd.post('/transporter', data)
    return res.data
  },
  async updateUserInfo(userId, data) {
    const res = await apiPrd.put(`/user/${userId}`, data)
    return res.data
  },
  async updateBasicInformation(data) {
    const res = await apiPrd.post('/transporter/updateBasicInfo', data)
    return res.data
  },
}

export default SettingsService
